<template>
    <el-dialog :title="setId ? '编辑账户' : '新增账户'" :visible.sync="accountDialog" :close-on-click-modal="false"
        :close-on-press-escape="false" :show-close="false" top="3%" width="600px" center>
        <el-form :model="accountForm" :rules="rules" ref="accountForm" label-width="100px">
            <el-form-item label="姓名" prop="name">
                <el-input v-model="accountForm.name" placeholder="请输入姓名"></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="phone">
                <el-input v-model="accountForm.phone" placeholder="请输入手机号"></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="pass">
                <el-input v-model="accountForm.pass" placeholder="请输入密码"></el-input>
            </el-form-item>
            <el-form-item label="性别" prop="sex">
                <el-radio-group v-model="accountForm.sex">
                    <el-radio :label="1">男</el-radio>
                    <el-radio :label="2">女</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="出生年月" prop="birthday">
                <el-date-picker v-model="accountForm.birthday" type="date" placeholder="选择日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="角色" prop="power">
                <el-select v-model="accountForm.power" placeholder="请选择角色" style="width: 100%;" :disabled="setId">
                    <el-option v-for="item in powerList" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="社区" prop="project"
                v-if="(accountForm.power === 8 || accountForm.power === 6) && [3].includes(user.power)">
                <el-select v-model="accountForm.project" placeholder="请选择社区" style="width: 100%;" :disabled="setId">
                    <el-option v-for="item in projectList" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="类型" prop="tags" v-if="accountForm.power === 8">
                <el-radio-group v-model="accountForm.tags">
                    <el-radio :label="1">楼门长</el-radio>
                    <el-radio :label="2">物业员工</el-radio>
                    <el-radio :label="3">居民</el-radio>
                    <el-radio :label="4">社会组织</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="是否是党员" prop="is_party">
                <el-radio-group v-model="accountForm.is_party">
                    <el-radio :label="0">否</el-radio>
                    <el-radio :label="1">是</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="从业年龄" prop="wordage">
                <el-input v-model="accountForm.wordage" placeholder="请输入从业年龄" type="number">
                    <template slot="append">年</template>
                </el-input>
            </el-form-item>

            <!--      <el-form-item label="所在小区" prop="xiaoqu_id">-->
            <!--        <el-select v-model="accountForm.xiaoqu_id" placeholder="请选择所在小区" clearable style="width: 100%;">-->
            <!--          <el-option-->
            <!--            v-for="item in xiaoqu"-->
            <!--            :key="item.id"-->
            <!--            :label="item.name"-->
            <!--            :value="item.id">-->
            <!--          </el-option>-->
            <!--        </el-select>-->
            <!--      </el-form-item>-->

            <el-form-item label="备注" prop="desc">
                <el-input type="textarea" v-model="accountForm.desc" placeholder="请输入备注"></el-input>
            </el-form-item>
            <el-form-item class="flex align-center justify-around" label-width="0">
                <el-button class="padding-lr-xl" @click="resetForm('accountForm')">取消</el-button>
                <el-button class="padding-lr-xl" type="primary" @click="submitForm('accountForm')">提交</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<script>
import { createAdminAccount } from "@/api/login";
import rules from '@/utils/rules'
import { getXiangMuList, getXiaoQuList } from "@/api/common";
import { zhDate } from "@/utils/utils";

export default {
    name: "accountDialog",
    props: {
        accountDialog: {
            type: Boolean,
            default: false
        },
        setId: {
            type: Number,
            default() {
                return 0;
            }
        },
        setItem: {
            type: Object
        }
    },
    data() {

        return {
            power: 0,
            accountForm: {
                name: '',
                phone: '',
                pass: '',
                wordage: '',
                power: '',
                desc: '',
                sex: '',
                birthday: '',
                is_party: '',
                tags: '',
                xiaoqu_id: '',
                project: '',
            },
            projectList: [],
            xiaoqu: [],
            rules: {
                name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
                phone: rules.phone,
                pass: [{ required: true, message: '请输入密码', trigger: 'blur' },
                {
                    pattern: '^(?=.*\\d)(?=.*[a-zA-Z])[a-zA-Z0-9]{8,20}$',
                    message: '密码需要包含数字及字母且8-20个字符',
                    trigger: 'change'
                }],
                wordage: [{ required: true, message: '请输入从业年龄', trigger: 'blur' }],
                power: [{ required: true, message: '请选择角色', trigger: 'change' }],
                project: [{ required: true, message: '请选择社区', trigger: 'change' }],
                sex: [{ required: true, message: '请选择性别', trigger: 'change' }],
                birthday: [{ required: true, message: '请选择出生年月', trigger: 'change' }],
                is_party: [{ required: true, message: '请选择是否是党员', trigger: 'change' }],
                tags: [{ required: true, message: '请选择员工类型', trigger: 'change' }],
            }
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
        powerList() {
            if (this.user.power === 3 || this.user.power === 4) {   //  总负责人和总负责人子账号
                return [
                    // {value: 4, label: '子管理员'},
                    { value: 5, label: '社区' },
                    { value: 9, label: '活动队长' },
                    { value: 6, label: '志愿者队长' }, { value: 8, label: '志愿者' }
                ]
            } else {
                return [{ value: 6, label: '志愿者队长' }, { value: 8, label: '志愿者' }]
                // {value: 7, label: '财务'},
            }
        }
    },
    created() {
        this.getXiaoQuList()
    },
    methods: {
        //  获取当前人员下的小区
        async getXiaoQuList() {
            const project = await getXiangMuList()
            this.projectList = project.data
            const res = await getXiaoQuList(project.data[0].id)
            this.xiaoqu = res.data
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.$emit('cancelDialog', false)
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submitData(formName)
                }
            });
        },
        async submitData(formName) {
            let _state = await createAdminAccount(
                this.accountForm.name,
                this.accountForm.phone,
                this.accountForm.pass,
                this.accountForm.wordage,
                this.accountForm.power,
                this.accountForm.desc,
                this.accountForm.sex,
                zhDate(new Date(this.accountForm.birthday)),
                this.accountForm.is_party,
                this.accountForm.power === 8 ? this.accountForm.tags : '',
                this.accountForm.xiaoqu_id,
                this.accountForm.project,
                this.setId ? this.setId : '',
            );
            this.$message.success(_state.info);
            this.$refs[formName].resetFields();
            this.$emit("cancelDialog", true);
        }

    },
    watch: {
        setItem() {
            this.accountForm = {
                name: this.setItem.name,
                phone: this.setItem.username,
                wordage: this.setItem.word_age,
                pass: '',
                power: this.setItem.power,
                desc: this.setItem.beizhu,
                sex: this.setItem.sex,
                birthday: this.setItem.birthday && this.setItem.birthday !== "0000-00-00" ? new Date(this.setItem.birthday) : '',
                is_party: this.setItem.is_party,
                tags: this.setItem.tags ? Number(this.setItem.tags) : '',
                project: this.setItem.xiangmu_id,
                xiaoqu_id: this.setItem.xiaoqu_id,

            };
            this.$refs.accountForm.clearValidate();
        },
    }
}
</script>

<style scoped lang="scss"></style>
